<template>
  <div class="loader contents-loader text-center">
    <div class="loader-circle"></div>

    <div class="loader-text mt-3">
      <template v-if="text">
        {{ text }}
      </template>

      <template v-else>
        Loading...
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ContentsLoader",
    props: {
      text: String
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/Loader/Contents.vue